export default __webpack_public_path__ + "static/media/tele1.4e1cd7d7.svg";